import { ChipOwnProps } from '@mui/material';
import {
  ACHFundingAccountStatusType,
  ACHFundingAccountStatus,
  ACHLocationStatus,
  ACHLocationStatusType,
  BeneficialOwnerStatus,
  BeneficialOwnerStatusType,
} from 'api/giftcard-ach-service/giftcard-ach-service.types';
import { useTranslation } from 'react-i18next';

export const useACHLocationStatus = (
  status:
    | ACHLocationStatusType
    | ACHFundingAccountStatusType
    | BeneficialOwnerStatusType,
) => {
  const { t } = useTranslation();
  let label, color: ChipOwnProps['color'] | undefined;

  switch (status) {
    case ACHLocationStatus.UNENROLLED:
      break;
    case ACHLocationStatus.FUNDING_SOURCE_REQUIRED:
      label = t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.fundingSourceRequired',
      );
      color = 'warning';
      break;
    case ACHLocationStatus.VERIFIED:
    case ACHFundingAccountStatus.VERIFIED:
      label = t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.verified',
      );
      color = 'success';
      break;
    case ACHLocationStatus.RETRY:
      label = t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.retry',
      );
      color = 'warning';
      break;
    case ACHLocationStatus.RETRY_VERIFICATION:
      label = t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.retryVerification',
      );
      color = 'warning';
      break;
    case ACHLocationStatus.RETRY_WITH_FULL_SSN:
      label = t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.retryWithFullSSN',
      );
      color = 'warning';
      break;
    case ACHLocationStatus.BENEFICIAL_OWNERSHIP_DOCUMENTS_SUBMITTED:
      label = t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.beneficialOwnershipDocumentsSubmitted',
      );
      color = 'warning';
      break;
    case ACHLocationStatus.PENDING_CERTIFY_BENEFICIAL_OWNERSHIP:
      label = t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.pendingCertifyBeneficialOwnership',
      );
      color = 'warning';
      break;
    case ACHLocationStatus.KBA:
      label = t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.kba',
      );
      color = 'warning';
      break;
    case ACHLocationStatus.DOCUMENT:
      label = t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.document',
      );
      color = 'warning';
      break;
    case ACHLocationStatus.SUSPENDED:
      label = t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.suspended',
      );
      color = 'error';
      break;
    case ACHLocationStatus.DEACTIVATED:
      label = t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.deactivated',
      );
      color = 'error';
      break;
    case ACHLocationStatus.UNVERIFIED:
      label = t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.unverified',
      );
      break;
    case BeneficialOwnerStatus.INCOMPLETE:
      label = t(
        'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.incomplete',
      );
      color = 'warning';
      break;
  }

  return { label, color };
};
